module.exports = __webpack_public_path__ + "img/21_22.434785d8.png";